import React from "react";
import { useTranslation } from "react-i18next";

import freshdeskMainImg from "../../assets/img/license-buy-freshdesk-main-info-img-effect.png";
import contentMasterMainImg from "../../assets/img/license-buy-content-master-main-info-img-effect.png";
import gpsrMainImg from "../../assets/img/license-buy-gpsr-main-info-img-effect.png";
import mobileMainImg from "../../assets/img/license-buy-mobile-main-info-img-effect.png";
import googleReviewManagerMainImg from "../../assets/img/license-buy-google-review-manager-main-info-img-effect.png";
import shipmentTrackerMainImg from "../../assets/img/license-buy-shipment-tracker-main-info-img-effect.png";

interface TopPromoProps {
  licenseType: string;
  className?: string;
}

const TopPromo: React.FC<TopPromoProps> = ({ licenseType, className = "" }) => {
  const { t } = useTranslation();

  const getRobotIcon = () => {
    switch (licenseType) {
      case "freshdesk":
        return freshdeskMainImg;
      case "content_master":
        return contentMasterMainImg;
      case "gpsr":
        return gpsrMainImg;
      case "google_review_manager":
        return googleReviewManagerMainImg;
      case "shipment_tracker":
        return shipmentTrackerMainImg;
      case "mobile":
        return mobileMainImg;
      default:
        return freshdeskMainImg;
    }
  };

  return (
    <div className={`top-promo ${className}`}>
      <div className="top-promo-banner">
        <div className="top-promo-content">
          <div className="top-promo-text">
            <h2 className="top-promo-title">
              {t(`${licenseType}.main_info.title`)}
              <br />
              {t(`${licenseType}.main_info.subtitle`)}
            </h2>
          </div>
          <div className="top-promo-robot">
            <div className="top-promo-description">
              <p className="top-promo-description-text-1">
                {t(`${licenseType}.main_info.description1`)}
              </p>
              <p className="top-promo-description-text-2">
                {t(`${licenseType}.main_info.description2`)}
              </p>
              <p className="top-promo-description-text-3">
                {t(`${licenseType}.main_info.description3`)}
              </p>
            </div>
            <div className="robot-icon">
              <img src={getRobotIcon()} alt="robot" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopPromo;
